const SUITS = ['♠', '♥', '♦', '♣'];
const RED_SUITS = ['♥', '♦'];

export const splitSymbol = (symbol = '') => {
  const last = symbol.slice(-1);
  if (SUITS.includes(last)) {
    return { rank: symbol.slice(0, -1), suit: last, isRed: RED_SUITS.includes(last) };
  }
  return { rank: symbol, suit: '', isRed: false };
};
